import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Index9() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="intro-section">
    <div className="intro-section-slider">
      <div className="container">
        <div className="intro-slider-container slider-container-ratio mb-0">
          <div className="intro-slider owl-carousel owl-simple owl-light" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;responsive&quot;: {
                      &quot;1200&quot;: {
                          &quot;nav&quot;: true,
                          &quot;dots&quot;: false
                      }
                  }
              }">
            <div className="intro-slide">
              <figure className="slide-image">
                <picture>
                  <source media="(max-width: 480px)" srcSet="asset/images/demos/demo-9/slider/slide-1-480w.jpg" />
                  <img src="asset/images/demos/demo-9/slider/slide-1.jpg" alt="Image Desc" />
                </picture>
              </figure>{/* End .slide-image */}
              <div className="intro-content">
                <h3 className="intro-subtitle">New Collection</h3>{/* End .h3 intro-subtitle */}
                <h1 className="intro-title text-white">Women’s <br />Sportswear &amp; Joggers</h1>{/* End .intro-title */}
                <div className="intro-text text-white">2019</div>{/* End .intro-text */}
                <a href="category.html" className="btn btn-primary">
                  <span>DISCOVER NOW</span>
                </a>
              </div>{/* End .intro-content */}
            </div>{/* End .intro-slide */}
            <div className="intro-slide">
              <figure className="slide-image">
                <picture>
                  <source media="(max-width: 480px)" srcSet="asset/images/demos/demo-9/slider/slide-2-480w.jpg" />
                  <img src="asset/images/demos/demo-9/slider/slide-2.jpg" alt="Image Desc" />
                </picture>
              </figure>{/* End .slide-image */}
              <div className="intro-content">
                <h3 className="intro-subtitle">New Collection</h3>{/* End .h3 intro-subtitle */}
                <h1 className="intro-title text-white">Men’s <br />Coats &amp; Jackets</h1>{/* End .intro-title */}
                <a href="category.html" className="btn btn-primary">
                  <span>DISCOVER NOW</span>
                </a>
              </div>{/* End .intro-content */}
            </div>{/* End .intro-slide */}
            <div className="intro-slide">
              <figure className="slide-image">
                <picture>
                  <source media="(max-width: 480px)" srcSet="asset/images/demos/demo-9/slider/slide-3-480w.jpg" />
                  <img src="asset/images/demos/demo-9/slider/slide-3.jpg" alt="Image Desc" />
                </picture>
              </figure>{/* End .slide-image */}
              <div className="intro-content">
                <h3 className="intro-subtitle">Deals and Promotions</h3>{/* End .h3 intro-subtitle */}
                <h1 className="intro-title text-white">Sneakers &amp; Athletic Shoes</h1>{/* End .intro-title */}
                <div className="intro-text text-white">from $9.99</div>{/* End .intro-text */}
                <a href="category.html" className="btn btn-primary">
                  <span>SHOP NOW</span>
                </a>
              </div>{/* End .intro-content */}
            </div>{/* End .intro-slide */}
          </div>{/* End .intro-slider owl-carousel owl-simple */}
          <span className="slider-loader" />{/* End .slider-loader */}
        </div>{/* End .intro-slider-container */}
      </div>{/* End .container */}
    </div>{/* End .intro-section-slider */}
    <div className="icon-boxes-container pt-0 pb-0">
      <div className="container">
        <div className="owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
              &quot;nav&quot;: false, 
              &quot;dots&quot;: false,
              &quot;margin&quot;: 30,
              &quot;loop&quot;: false,
              &quot;autoplay&quot;: true,
              &quot;autoplayTimeout&quot;: 8000,
              &quot;responsive&quot;: {
                  &quot;0&quot;: {
                      &quot;items&quot;:1
                  },
                  &quot;480&quot;: {
                      &quot;items&quot;:2
                  },
                  &quot;992&quot;: {
                      &quot;items&quot;:3
                  },
                  &quot;1200&quot;: {
                      &quot;items&quot;:4
                  }
              }
          }">
          <div className="icon-box icon-box-side">
            <span className="icon-box-icon">
              <i className="icon-rocket" />
            </span>
            <div className="icon-box-content">
              <h3 className="icon-box-title">Free Shipping</h3>{/* End .icon-box-title */}
              <p>Orders $50 or more</p>
            </div>{/* End .icon-box-content */}
          </div>{/* End .icon-box */}
          <div className="icon-box icon-box-side">
            <span className="icon-box-icon">
              <i className="icon-rotate-left" />
            </span>
            <div className="icon-box-content">
              <h3 className="icon-box-title">Free Returns</h3>{/* End .icon-box-title */}
              <p>Within 30 days</p>
            </div>{/* End .icon-box-content */}
          </div>{/* End .icon-box */}
          <div className="icon-box icon-box-side">
            <span className="icon-box-icon">
              <i className="icon-info-circle" />
            </span>
            <div className="icon-box-content">
              <h3 className="icon-box-title">Get 20% Off 1 Item</h3>{/* End .icon-box-title */}
              <p>When you sign up</p>
            </div>{/* End .icon-box-content */}
          </div>{/* End .icon-box */}
          <div className="icon-box icon-box-side">
            <span className="icon-box-icon">
              <i className="icon-life-ring" />
            </span>
            <div className="icon-box-content">
              <h3 className="icon-box-title">We Support</h3>{/* End .icon-box-title */}
              <p>24/7 amazing services</p>
            </div>{/* End .icon-box-content */}
          </div>{/* End .icon-box */}
        </div>{/* End .owl-carousel */}
      </div>{/* End .container */}
    </div>{/* End .icon-boxes-container */}
  </div>{/* End .intro-section */}
  <div className="pt-3 pb-3">
    <div className="container">
      <div className="banner-group">
        <div className="row">
          <div className="col-sm-6 col-lg-4">
            <div className="banner banner-overlay banner-lg">
              <a href="#">
                <img src="asset/images/demos/demo-9/banners/banner-1.jpg" alt="Banner" />
              </a>
              <div className="banner-content banner-content-bottom">
                <h4 className="banner-subtitle text-white"><a href="#">Clearance</a></h4>{/* End .banner-subtitle */}
                <h3 className="banner-title text-white"><a href="#">Waterproof</a></h3>{/* End .banner-title */}
                <div className="banner-text text-white"><a href="#">from $19.00</a></div>{/* End .banner-text */}
                <a href="#" className="btn btn-outline-white banner-link">Discover Now</a>
              </div>{/* End .banner-content */}
            </div>{/* End .banner */}
          </div>{/* End .col-lg-4 */}
          <div className="col-sm-6 col-lg-4 order-lg-last">
            <div className="banner banner-overlay banner-lg">
              <a href="#">
                <img src="asset/images/demos/demo-9/banners/banner-4.jpg" alt="Banner" />
              </a>
              <div className="banner-content banner-content-top">
                <h4 className="banner-subtitle text-white"><a href="#">On Sale</a></h4>{/* End .banner-subtitle */}
                <h3 className="banner-title text-white"><a href="#">Women's<br />Sportswear</a></h3>{/* End .banner-title */}
                <div className="banner-text text-white"><a href="#">from $39.00</a></div>{/* End .banner-text */}
                <a href="#" className="btn btn-outline-white banner-link">Discover Now</a>
              </div>{/* End .banner-content */}
            </div>{/* End .banner */}
          </div>{/* End .col-lg-4 */}
          <div className="col-12 col-lg-4">
            <div className="row">
              <div className="col-sm-6 col-lg-12">
                <div className="banner banner-overlay">
                  <a href="#">
                    <img src="asset/images/demos/demo-9/banners/banner-2.jpg" alt="Banner" />
                  </a>
                  <div className="banner-content">
                    <h4 className="banner-subtitle text-white"><a href="#">New Arrivals</a></h4>{/* End .banner-subtitle */}
                    <h3 className="banner-title text-white"><a href="#">Accessories<br />and Shoes</a></h3>{/* End .banner-title */}
                    <a href="#" className="btn btn-outline-white banner-link">Shop Now</a>
                  </div>{/* End .banner-content */}
                </div>{/* End .banner */}
              </div>{/* End .col-sm-6 col-lg-12 */}
              <div className="col-sm-6 col-lg-12">
                <div className="banner banner-overlay">
                  <a href="#">
                    <img src="asset/images/demos/demo-9/banners/banner-3.jpg" alt="Banner" />
                  </a>
                  <div className="banner-content">
                    <h4 className="banner-subtitle text-white"><a href="#">New Arrivals</a></h4>{/* End .banner-subtitle */}
                    <h3 className="banner-title text-white"><a href="#">Spring 2019</a></h3>{/* End .banner-title */}
                    <a href="#" className="btn btn-outline-white banner-link">Shop Now</a>
                  </div>{/* End .banner-content */}
                </div>{/* End .banner */}
              </div>{/* End .col-sm-6 col-lg-12 */}
            </div>{/* End .row */}
          </div>{/* End .col-lg-4 */}
        </div>{/* End .row */}
      </div>{/* End .banner-group */}
      <div className="owl-carousel mt-4 mb-3 owl-simple" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: false,
          &quot;margin&quot;: 30,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;0&quot;: {
                  &quot;items&quot;:2
              },
              &quot;420&quot;: {
                  &quot;items&quot;:3
              },
              &quot;600&quot;: {
                  &quot;items&quot;:4
              },
              &quot;900&quot;: {
                  &quot;items&quot;:5
              },
              &quot;1024&quot;: {
                  &quot;items&quot;:6
              }
          }
      }">
        <a href="#" className="brand">
          <img src="asset/images/brands/1.png" alt="Brand Name" />
        </a>
        <a href="#" className="brand">
          <img src="asset/images/brands/2.png" alt="Brand Name" />
        </a>
        <a href="#" className="brand">
          <img src="asset/images/brands/3.png" alt="Brand Name" />
        </a>
        <a href="#" className="brand">
          <img src="asset/images/brands/4.png" alt="Brand Name" />
        </a>
        <a href="#" className="brand">
          <img src="asset/images/brands/5.png" alt="Brand Name" />
        </a>
        <a href="#" className="brand">
          <img src="asset/images/brands/6.png" alt="Brand Name" />
        </a>
        <a href="#" className="brand">
          <img src="asset/images/brands/7.png" alt="Brand Name" />
        </a>
      </div>{/* End .owl-carousel */}
    </div>{/* End .container */}
  </div>{/* End .bg-lighter */}
  <div className="bg-lighter pt-6">
    <div className="container">
      <div className="heading heading-flex mb-3">
        <div className="heading-left">
          <h2 className="title">Trending Now</h2>{/* End .title */}
        </div>{/* End .heading-left */}
        <div className="heading-right">
          <ul className="nav nav-pills nav-border-anim justify-content-center" role="tablist">
            <li className="nav-item">
              <a className="nav-link active" id="trending-women-link" data-toggle="tab" href="#trending-women-tab" role="tab" aria-controls="trending-women-tab" aria-selected="true">Women's Clothing</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="trending-men-link" data-toggle="tab" href="#trending-men-tab" role="tab" aria-controls="trending-men-tab" aria-selected="false">Men's Clothing</a>
            </li>
          </ul>
        </div>{/* End .heading-right */}
      </div>{/* End .heading */}
      <div className="tab-content tab-content-carousel">
        <div className="tab-pane p-0 fade show active" id="trending-women-tab" role="tabpanel" aria-labelledby="trending-women-link">
          <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;margin&quot;: 20,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;480&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;768&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;992&quot;: {
                          &quot;items&quot;:4
                      },
                      &quot;1200&quot;: {
                          &quot;items&quot;:4,
                          &quot;dots&quot;: false
                      }
                  }
              }">
            <div className="product product-7 text-center">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-9/products/product-1-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-9/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Denim jacket</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $19.99
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 6 Reviews )</span>
                </div>{/* End .rating-container */}
                <div className="product-nav product-nav-thumbs">
                  <a href="#" className="active">
                    <img src="asset/images/demos/demo-9/products/product-1-thumb.jpg" alt="product desc" />
                  </a>
                  <a href="#">
                    <img src="asset/images/demos/demo-9/products/product-1-2-thumb.jpg" alt="product desc" />
                  </a>
                  <a href="#">
                    <img src="asset/images/demos/demo-9/products/product-1-3-thumb.jpg" alt="product desc" />
                  </a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product product-7 text-center">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-9/products/product-2-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-9/products/product-2-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Sandals</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $24.99
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 2 Reviews )</span>
                </div>{/* End .rating-container */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product product-7 text-center">
              <figure className="product-media">
                <span className="product-label label-sale">sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-9/products/product-3-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-9/products/product-3-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Printed sweatshirt</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">Now $7.99</span>
                  <span className="old-price">Was $12.99</span>
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 3 Reviews )</span>
                </div>{/* End .rating-container */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product product-7 text-center">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-9/products/product-4-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-9/products/product-4-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Linen-blend paper bag trousers</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $17.99
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 2 Reviews )</span>
                </div>{/* End .rating-container */}
                <div className="product-nav product-nav-thumbs">
                  <a href="#" className="active">
                    <img src="asset/images/demos/demo-9/products/product-4-thumb.jpg" alt="product desc" />
                  </a>
                  <a href="#">
                    <img src="asset/images/demos/demo-9/products/product-4-2-thumb.jpg" alt="product desc" />
                  </a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product product-7 text-center">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-9/products/product-1-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-9/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Denim jacket</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $19.99
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 6 Reviews )</span>
                </div>{/* End .rating-container */}
                <div className="product-nav product-nav-thumbs">
                  <a href="#" className="active">
                    <img src="asset/images/demos/demo-9/products/product-1-thumb.jpg" alt="product desc" />
                  </a>
                  <a href="#">
                    <img src="asset/images/demos/demo-9/products/product-1-2-thumb.jpg" alt="product desc" />
                  </a>
                  <a href="#">
                    <img src="asset/images/demos/demo-9/products/product-1-3-thumb.jpg" alt="product desc" />
                  </a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .owl-carousel */}
        </div>{/* .End .tab-pane */}
        <div className="tab-pane p-0 fade" id="trending-men-tab" role="tabpanel" aria-labelledby="trending-men-link">
          <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;margin&quot;: 20,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;480&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;768&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;992&quot;: {
                          &quot;items&quot;:4
                      },
                      &quot;1200&quot;: {
                          &quot;items&quot;:4,
                          &quot;dots&quot;: false
                      }
                  }
              }">
          </div>{/* End .owl-carousel */}
        </div>{/* .End .tab-pane */}
      </div>{/* End .tab-content */}
    </div>{/* End .container */}
  </div>
  <div className="container featured mt-4 pb-2">
    <div className="heading heading-flex mb-3">
      <div className="heading-left">
        <h2 className="title">Featured Footwear</h2>{/* End .title */}
      </div>{/* End .heading-left */}
      <div className="heading-right">
        <ul className="nav nav-pills nav-border-anim justify-content-center" role="tablist">
          <li className="nav-item">
            <a className="nav-link active" id="featured-women-link" data-toggle="tab" href="#featured-women-tab" role="tab" aria-controls="featured-women-tab" aria-selected="true">Women's Shoes</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="featured-men-link" data-toggle="tab" href="#featured-men-tab" role="tab" aria-controls="featured-men-tab" aria-selected="false">Men's Shoes</a>
          </li>
        </ul>
      </div>{/* End .heading-right */}
    </div>{/* End .heading */}
    <div className="row">
      <div className="col-lg-3">
        <div className="banner banner-overlay product-banner">
          <a href="#">
            <img src="asset/images/demos/demo-9/banners/banner-5.jpg" alt="banner image" />
          </a>
          <div className="banner-content">
            <div className="banner-top">
              <div className="banner-title text-white text-center">
                <i className="la la-star-o" /><h3 className="text-white">Our Experts<br />Recommend</h3>
              </div>
            </div>
            <div className="banner-bottom">
              <div className="product-cat">
                <h4 className="text-white">Sale</h4>
              </div>
              <div className="product-price">
                <h4 className="text-white">$29.99</h4>
              </div>
              <div className="product-txt">
                <p className="text-white">Wedge-heel sandals</p>
              </div>
              <a href="#" className="btn btn-outline-white banner-link">Shop Now</a>
            </div>
          </div>
        </div>{/* End .banner banner-overlay */}
      </div>{/* End .col-lg-3 */}
      <div className="col-lg-9">
        <div className="tab-content tab-content-carousel">
          <div className="tab-pane p-0 fade show active" id="featured-women-tab" role="tabpanel" aria-labelledby="featured-women-link">
            <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
                      &quot;nav&quot;: false, 
                      &quot;dots&quot;: true,
                      &quot;margin&quot;: 20,
                      &quot;loop&quot;: false,
                      &quot;responsive&quot;: {
                          &quot;0&quot;: {
                              &quot;items&quot;:2
                          },
                          &quot;480&quot;: {
                              &quot;items&quot;:2
                          },
                          &quot;768&quot;: {
                              &quot;items&quot;:3
                          },
                          &quot;992&quot;: {
                              &quot;items&quot;:3,
                              &quot;nav&quot;: true,
                              &quot;dots&quot;: false
                          }
                      }
                  }">
              <div className="product product-7">
                <figure className="product-media">
                  <span className="product-label label-sale">30% off</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-9/products/product-5-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-9/products/product-5-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Trainers</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    <span className="new-price">Now $19.99</span>
                    <span className="old-price">Was $29.99</span>
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 6 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
              <div className="product product-7">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-9/products/product-6-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-9/products/product-6-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Sandals</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $12.99
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 4 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
              <div className="product product-7">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-9/products/product-7-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-9/products/product-7-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Loafers</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $9.99
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 2 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
              <div className="product product-7">
                <figure className="product-media">
                  <span className="product-label label-sale">30% off</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-9/products/product-5-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-9/products/product-5-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Trainers</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    <span className="new-price">Now $19.99</span>
                    <span className="old-price">Was $29.99</span>
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 6 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .owl-carousel */}
          </div>{/* .End .tab-pane */}
          <div className="tab-pane p-0 fade" id="featured-men-tab" role="tabpanel" aria-labelledby="featured-men-link">
            <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
                      &quot;nav&quot;: false, 
                      &quot;dots&quot;: true,
                      &quot;margin&quot;: 20,
                      &quot;loop&quot;: false,
                      &quot;responsive&quot;: {
                          &quot;0&quot;: {
                              &quot;items&quot;:1
                          },
                          &quot;480&quot;: {
                              &quot;items&quot;:2
                          },
                          &quot;768&quot;: {
                              &quot;items&quot;:3
                          },
                          &quot;992&quot;: {
                              &quot;items&quot;:3,
                              &quot;dots&quot;: false
                          }
                      }
                  }">
            </div>{/* End .owl-carousel */}
          </div>{/* .End .tab-pane */}
        </div>{/* End .tab-content */}
      </div>{/* End .col-lg-9 */}
    </div>{/* End .row */}
  </div>{/* End .container */}
  <div className="container">
    <hr className="mt-3 mb-4" />
  </div>{/* End .container */}
  <div className="container pb-2">
    <div className="heading heading-flex mb-3">
      <div className="heading-left">
        <h2 className="title">Bags &amp; Accessories</h2>{/* End .title */}
      </div>{/* End .heading-left */}
      <div className="heading-right">
        <ul className="nav nav-pills nav-border-anim justify-content-center" role="tablist">
          <li className="nav-item">
            <a className="nav-link active" id="bags-women-link" data-toggle="tab" href="#bags-women-tab" role="tab" aria-controls="bags-women-tab" aria-selected="true">Women's</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="bags-men-link" data-toggle="tab" href="#bags-men-tab" role="tab" aria-controls="bags-men-tab" aria-selected="false">Men's</a>
          </li>
        </ul>
      </div>{/* End .heading-right */}
    </div>{/* End .heading */}
    <div className="row">
      <div className="col-lg-3">
        <div className="banner banner-overlay product-banner">
          <a href="#">
            <img src="asset/images/demos/demo-9/banners/banner-6.jpg" alt="banner image" />
          </a>
          <div className="banner-content">
            <div className="banner-top">
              <div className="banner-title text-white text-center">
                <i className="la la-star-o" /><h3 className="text-white">Our Experts<br />Recommend</h3>
              </div>
            </div>
            <div className="banner-bottom">
              <div className="product-cat">
                <h4 className="text-white">Sale</h4>
              </div>
              <div className="product-price">
                <h4 className="text-white">$129.99</h4>
              </div>
              <div className="product-txt">
                <p className="text-white">Cross Body Bag</p>
              </div>
              <a href="#" className="btn btn-outline-white banner-link">Shop Now</a>
            </div>
          </div>
        </div>{/* End .banner banner-overlay */}
      </div>{/* End .col-lg-3 */}
      <div className="col-lg-9">
        <div className="tab-content tab-content-carousel">
          <div className="tab-pane p-0 fade show active" id="bags-women-tab" role="tabpanel" aria-labelledby="bags-women-link">
            <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
                      &quot;nav&quot;: false, 
                      &quot;dots&quot;: true,
                      &quot;margin&quot;: 20,
                      &quot;loop&quot;: false,
                      &quot;responsive&quot;: {
                          &quot;0&quot;: {
                              &quot;items&quot;:2
                          },
                          &quot;480&quot;: {
                              &quot;items&quot;:2
                          },
                          &quot;768&quot;: {
                              &quot;items&quot;:3
                          },
                          &quot;1200&quot;: {
                              &quot;items&quot;:3,
                              &quot;nav&quot;: true,
                              &quot;dots&quot;: false
                          }
                      }
                  }">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-9/products/product-8-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-9/products/product-8-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Small shoulder bag</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $14.99
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 2 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-9/products/product-9-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-9/products/product-9-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Loafers</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $9.99
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '40%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 1 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-9/products/product-10-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-9/products/product-10-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Small bucket bag</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $14.99
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 3 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-nav product-nav-thumbs">
                    <a href="#" className="active">
                      <img src="asset/images/demos/demo-9/products/product-10-thumb.jpg" alt="product desc" />
                    </a>
                    <a href="#">
                      <img src="asset/images/demos/demo-9/products/product-10-2-thumb.jpg" alt="product desc" />
                    </a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .owl-carousel */}
          </div>{/* .End .tab-pane */}
          <div className="tab-pane p-0 fade" id="bags-men-tab" role="tabpanel" aria-labelledby="bags-men-link">
            <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
                      &quot;nav&quot;: false, 
                      &quot;dots&quot;: true,
                      &quot;margin&quot;: 20,
                      &quot;loop&quot;: false,
                      &quot;responsive&quot;: {
                          &quot;0&quot;: {
                              &quot;items&quot;:2
                          },
                          &quot;480&quot;: {
                              &quot;items&quot;:2
                          },
                          &quot;768&quot;: {
                              &quot;items&quot;:3
                          },
                          &quot;992&quot;: {
                              &quot;items&quot;:4
                          },
                          &quot;1200&quot;: {
                              &quot;items&quot;:4,
                              &quot;nav&quot;: true,
                              &quot;dots&quot;: false
                          }
                      }
                  }">
            </div>{/* End .owl-carousel */}
          </div>{/* .End .tab-pane */}
        </div>{/* End .tab-content */}
      </div>
    </div>
  </div>{/* End .container */}
  <div className="container">
    <hr className="mt-3 mt-xl-1 mb-0" />
  </div>{/* End .container */}
  <div className="cta pt-4 pt-lg-6 pb-5 pb-lg-7 mb-0">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-sm-10 col-md-8 col-lg-6">
          <div className="cta-heading text-center">
            <h3 className="cta-title">Sign Up for updates from Molla</h3>{/* End .cta-title */}
            <p className="cta-desc">and receive <span className="font-weight-normal">$20 coupon</span> for first shopping</p>{/* End .cta-desc */}
          </div>{/* End .text-center */}
          <form action="#">
            <div className="input-group">
              <input type="email" className="form-control" placeholder="Enter your Email Address" aria-label="Email Adress" required />
              <div className="input-group-append">
                <button className="btn btn-primary" type="submit" title="Sing up"><i className="icon-long-arrow-right" /></button>
              </div>{/* .End .input-group-append */}
            </div>{/* .End .input-group */}
          </form>
        </div>{/* End .col-sm-10 col-md-8 col-lg-6 */}
      </div>{/* End .row */}
    </div>{/* End .container */}
  </div>{/* End .cta */}
  <div className="owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
  &quot;nav&quot;: false, 
  &quot;dots&quot;: false,
  &quot;items&quot;: 6,
  &quot;margin&quot;: 0,
  &quot;loop&quot;: false,
  &quot;responsive&quot;: {
      &quot;0&quot;: {
          &quot;items&quot;:2
      },
      &quot;360&quot;: {
          &quot;items&quot;:2
      },
      &quot;600&quot;: {
          &quot;items&quot;:3
      },
      &quot;992&quot;: {
          &quot;items&quot;:4
      },
      &quot;1200&quot;: {
          &quot;items&quot;:5
      },
      &quot;1500&quot;: {
          &quot;items&quot;:6
      }
  }
    }">
    <div className="instagram-feed">
      <img src="asset/images/demos/demo-9/instagram/1.jpg" alt="img" />
      <div className="instagram-feed-content">
        <a href="#"><i className="icon-heart-o" />466</a>
        <a href="#"><i className="icon-comments" />65</a>
      </div>{/* End .instagram-feed-content */}
    </div>{/* End .instagram-feed */}
    <div className="instagram-feed">
      <img src="asset/images/demos/demo-9/instagram/2.jpg" alt="img" />
      <div className="instagram-feed-content">
        <a href="#"><i className="icon-heart-o" />39</a>
        <a href="#"><i className="icon-comments" />78</a>
      </div>{/* End .instagram-feed-content */}
    </div>{/* End .instagram-feed */}
    <div className="instagram-feed">
      <img src="asset/images/demos/demo-9/instagram/3.jpg" alt="img" />
      <div className="instagram-feed-content">
        <a href="#"><i className="icon-heart-o" />691</a>
        <a href="#"><i className="icon-comments" />87</a>
      </div>{/* End .instagram-feed-content */}
    </div>{/* End .instagram-feed */}
    <div className="instagram-feed">
      <img src="asset/images/demos/demo-9/instagram/4.jpg" alt="img" />
      <div className="instagram-feed-content">
        <a href="#"><i className="icon-heart-o" />508</a>
        <a href="#"><i className="icon-comments" />124</a>
      </div>{/* End .instagram-feed-content */}
    </div>{/* End .instagram-feed */}
    <div className="instagram-feed">
      <img src="asset/images/demos/demo-9/instagram/5.jpg" alt="img" />
      <div className="instagram-feed-content">
        <a href="#"><i className="icon-heart-o" />433</a>
        <a href="#"><i className="icon-comments" />27</a>
      </div>{/* End .instagram-feed-content */}
    </div>{/* End .instagram-feed */}
    <div className="instagram-feed">
      <img src="asset/images/demos/demo-9/instagram/6.jpg" alt="img" />
      <div className="instagram-feed-content">
        <a href="#"><i className="icon-heart-o" />122</a>
        <a href="#"><i className="icon-comments" />55</a>
      </div>{/* End .instagram-feed-content */}
    </div>{/* End .instagram-feed */}
  </div>{/* End .owl-carousel */}
</main>

        <UserFooter/>
    </div>
  )
}

export default Index9